import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PopupService } from '../../../../services/popup.service';
import { RetailerService } from '../../../../services/retailer.service';
import { PropertyService } from '../../../../services/property.service';
import { LoaderService } from '../../../../services/loader.service';
import { Observable } from 'rxjs/Rx';
import { states } from '../../../../constants/Global';
import { MyStuffService } from '../../../../services/my-stuff.service';

@Component({
  selector: 'app-retailer-section',
  templateUrl: './retailer-section.component.html',
  styleUrls: ['./retailer-section.component.less']
})
export class RetailerSectionComponent implements OnInit {

  states = states;

  constructor(public popupService: PopupService, public retailerService: RetailerService,
              public propertyService: PropertyService, public ref: ChangeDetectorRef,
              public loaderService : LoaderService, public myStuffService: MyStuffService) { }

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.allRetailers) {
      this.retailerService.fetchRetailersSource.next(true);
      this.myStuffService.myStuffSectionOpened.allRetailers = true;
    }
  }

  ngAfterViewInit() {
    this.retailerService.addInputEventObservable();
  }

  applyWidth(item) {
    if(item.logoPinImage && item.logoPinImage.url) {
      if(item.logoPinImage.originalWidth && item.logoPinImage.originalHeight) {
        return item.logoPinImage.originalWidth >= item.logoPinImage.originalHeight;
      } else {
        return true;
      }
    } else if(item.smallPinImage && item.smallPinImage.url) {
      if(item.smallPinImage.originalWidth && item.smallPinImage.originalHeight) {
        return item.smallPinImage.originalWidth >= item.smallPinImage.originalHeight;
      } else {
        return true;
      }
    }
    return false;
  }

  applyHeight(item) {
    if(item.logoPinImage && item.logoPinImage.url) {
      if(item.logoPinImage.originalWidth && item.logoPinImage.originalHeight) {
        return item.logoPinImage.originalWidth < item.logoPinImage.originalHeight;
      } else {
        return true;
      }
    } else if(item.smallPinImage && item.smallPinImage.url) {
      if(item.smallPinImage.originalWidth && item.smallPinImage.originalHeight) {
        return item.smallPinImage.originalWidth < item.smallPinImage.originalHeight;
      } else {
        return true;
      }
    }
    return false;
  }

  paginate() {
    this.retailerService.fetchRetailers();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/retailer-section/retailer-section.component.ts